import { useReveal } from "../hooks/useReveal";
import { ParallaxBg } from "../components/ParallaxBg";
import { VideoEmbed } from "../components/VideoEmbed";
import { AUDIENCE_CARDS } from "../lib/copy";

const Card = ({ c, i }) => (
  <div className="audience-card reveal-up flex-1" data-testid={`audience-card-${i + 1}`}>
    <i className={`${c.icon} mb-4 block`}></i>
    <p className="text-sm md:text-base font-medium" style={{ color: "rgba(240,236,228,0.85)", lineHeight: 1.6 }}>{c.text}</p>
  </div>
);

export default function Audience() {
  const ref = useReveal();
  return (
    <section id="learn" ref={ref} className="relative overflow-hidden py-28 md:py-36" data-testid="audience-section">
      <ParallaxBg image="/bg/home3.jpg" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
        <p className="section-label mb-8 reveal-up">[004] — WHO THIS IS FOR</p>
        <h2 className="reveal-up font-black uppercase mb-14" style={{ fontSize: "clamp(28px, 3.6vw, 48px)", letterSpacing: "-0.02em" }}>
          THIS TRAINING IS DESIGNED FOR:
        </h2>
        <div className="grid lg:grid-cols-3 gap-4 mb-14">
          <div className="flex flex-col gap-4 order-2 lg:order-1">
            {AUDIENCE_CARDS.slice(0, 3).map((c, i) => <Card key={i} c={c} i={i} />)}
          </div>
          <div className="reveal-up order-1 lg:order-2 lg:h-full">
            <div className="hero-video-frame audience-video-frame" data-testid="audience-video">
              <VideoEmbed
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_va-loan-guide/artifacts/70k8d4z6_BOF%201.mp4"
                poster="/poster-bof.jpg"
                testid="audience-video-player"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4 order-3">
            {AUDIENCE_CARDS.slice(3).map((c, i) => <Card key={i} c={c} i={i + 3} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
